var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          attrs: {
            drag: "",
            action: "1",
            headers: {
              loginUserToken: _vm.Storage.l.get("TokenKey"),
            },
            "show-file-list": "",
            "on-exceed": _vm.handleExceed,
            "before-upload": _vm.beforeUpload,
            "on-preview": _vm.handlePreview,
            "on-change": _vm.handleChange,
            "on-remove": _vm.handleRemove,
            "before-remove": _vm.beforeRemove,
            "on-success": _vm.handleSuccess,
            limit: 40,
            accept: ".xls, .xlsx",
            "file-list": _vm.fileList,
            "auto-upload": false,
            multiple: "",
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("将文件拖到此处，或"),
            _c("em", [_vm._v("点击上传")]),
          ]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v(" 只能上传excel文件，且不超过40M ")]
          ),
        ]
      ),
      _vm.fileList.length
        ? _c(
            "div",
            { staticClass: "flex" },
            [
              _c("el-upload", {
                staticClass: "upload-demo",
                attrs: {
                  action: "1",
                  disabled: "",
                  "auto-upload": false,
                  "file-list": _vm.fileList,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.formConfig.exportMessage) },
      }),
      _c(
        "div",
        { staticClass: "dialog-footer" },
        [
          _vm.flag
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.uploadLoading,
                    size: "small",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.startUpload(false)
                    },
                  },
                },
                [_vm._v("开始上传 ")]
              )
            : _c(
                "el-button",
                {
                  attrs: {
                    type: "info",
                    plain: "",
                    loading: false,
                    size: "small",
                  },
                },
                [_vm._v("开始上传 ")]
              ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.download_modal },
            },
            [_vm._v("下载模板 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "small", icon: "el-icon-close" },
              on: { click: _vm.dialog_btnClose },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }